<div class="voucher-list-item">
  <div class="voucher-image">
    <img [alt]="voucher().imageUrl" [src]="voucher().imageUrl">
  </div>
  <div class="voucher-content">
    <div class="voucher-code">
      {{ voucher().code }}
    </div>
    <div class="voucher-product-name">
      <span>{{ voucher().productQuantity }}x Gratis {{ voucher().productName }}</span>
    </div>
  </div>
  <ui-icon-button class="voucher-delete" buttonStyle="unthemed" icon="trash" iconStyle="light" (click)="deleteVoucher.emit(voucher().code)" [loading]="deleting()" [disabled]="deleting()" />
</div>
